import React from "react";
import { Link } from "react-router-dom";
import { ALTERNATIVES } from "../../data/alternatives";

const product = [
  { label: "Reply Agent", to: "/reply-agent" },
  { label: "Lead Inbox", to: "/lead-inbox" },
  { label: "Brand Voice", to: "/brand-voice-feature" },
  { label: "Pricing", to: "/pricing" },
  { label: "Case Studies", to: "/case-studies" },
  { label: "Docs", to: "/docs" },
];

const guides = [
  { label: "Find leads on X (Twitter)", to: "/twitter-lead-generation" },
  { label: "Find leads on LinkedIn", to: "/linkedin-lead-generation" },
  { label: "Find leads on Reddit", to: "/reddit-lead-generation" },
  { label: "X vs LinkedIn vs Reddit", to: "/lead-generation" },
  { label: "Blog", to: "/blog" },
];

const company = [
  { label: "About", to: "/about" },
  { label: "Blog", to: "/blog" },
  { label: "Careers", to: "/careers" },
  { label: "Press", to: "/press" },
];

const legal = [
  { label: "Terms", to: "/terms" },
  { label: "Privacy", to: "/privacy" },
  { label: "DPA", to: "/dpa" },
  { label: "Status", to: "/status" },
];

export default function MarketingFooter() {
  const altLinks = [
    { label: "All alternatives", to: "/alternatives" },
    ...ALTERNATIVES.map((a) => ({
      label: `Alternative to ${a.name}`,
      to: `/alternatives/${a.slug}`,
    })),
  ];

  return (
    <footer className="bg-blue-400 text-white/70">
      <div className="max-w-7xl mx-auto px-6 py-14 grid md:grid-cols-6 gap-8 text-sm">
        <div className="md:col-span-1">
          <Link to="/" className="flex items-center gap-2">
            <img
              src="/collavue-logo-256.png"
              alt="Collavue"
              width="64"
              height="64"
              loading="lazy"
              decoding="async"
              className="w-16 h-16 rounded-md object-cover"
            />
          </Link>
          <p className="mt-3 text-white/55">
            AI lead discovery for human teams. Find people asking for what you offer
            on X, LinkedIn, and Reddit — then reply like a human.
          </p>
        </div>

        <FooterCol title="Product" items={product} />
        <FooterCol title="Guides" items={guides} />
        <FooterCol title="Company" items={company} />
        <FooterCol title="Legal" items={legal} />
        <FooterCol title="Alternatives" items={altLinks} />
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 text-xs text-white/50 flex flex-col sm:flex-row gap-2 sm:gap-0 justify-between">
          <span>© {new Date().getFullYear()} Collavue, Inc. All rights reserved.</span>
          <span>collavue.com</span>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, items }) {
  return (
    <div>
      <div className="text-white font-medium">{title}</div>
      <ul className="mt-3 space-y-2">
        {items.map((i) => (
          <li key={i.to}>
            <Link to={i.to} className="hover:text-white transition-colors">
              {i.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
